// @ts-nocheck
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";
import { useToast } from '@/hooks/use-toast';

type ProductUpdateBody = {
  description: Record<string, any>;
  enabled: boolean;
  top_offer: boolean;
  name: string;
  type: string;
  subscription_type_id: number;
};

const productUpdate = async (placeId: string, productId: string, body: ProductUpdateBody) => {
  console.log("Données envoyées à l'API :", body);
  const { data } = await axiosInstance.patch(
    `/api/abo/resamania2/products/${productId}?msdsId=${placeId}`,
    body
  );
  return data;
};

export const useProductUpdate = ({placeId, productId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ProductUpdateBody) =>
      productUpdate(placeId, productId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['products', placeId],
      });
      queryClient.refetchQueries(['products', placeId]);
      toast({
        variant: "default",
        title: "Votre configuration a été mise à jour",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};
